// @flow
import { connect } from 'react-redux'
import AdPreview, { type Props } from './AdPreview'
import { getAdvertisement, getMedia, hasAdvertisementAnyErrors } from '../../redux/selectors'
import type { Store } from '../../redux/ducks'
import type { AdvertisementStatistics, AudienceData, Configs } from '../types'
import _ from 'lodash'

type OwnProps = {|
  action: 'copy' | 'update' | 'create',
  providers: Array<string>,
  audienceType: string,
  statistics?: AdvertisementStatistics,
  isDisabled: boolean,
  onToggle: Function,
  checked?: boolean,
  storeId: string,
  disabled?: boolean,
  configs: Configs,
  audienceData: AudienceData
|}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const { storeId } = ownProps
  const advertisement = getAdvertisement(state, storeId)
  const { multiImageStoreId } = advertisement
  const image = multiImageStoreId ? getMedia(state, multiImageStoreId) : null

  return {
    advertisement,
    image,
    dataStatus: ownProps.isDisabled
      ? 'disabled'
      : hasAdvertisementAnyErrors(state, ownProps.storeId)
      ? 'errors'
      : 'correct'
  }
}

const AdPreviewContainer = connect<Props, OwnProps, _, _, _, _>(mapStateToProps)(AdPreview)

export default AdPreviewContainer
